import Vue from 'vue';
import Router from 'vue-router';

const Cases = () => import(/* webpackChunkName: "cases" */ '@/views/Cases.vue');
const Ceniky = () => import(/* webpackChunkName: "ceniky" */ '@/views/Ceniky.vue');
const Dashboard = () => import(/* webpackChunkName: "dashboard" */ '@/views/Dashboard.vue');
const Klienti = () => import(/* webpackChunkName: "klienti" */ '@/views/Klienti.vue');
const Login = () => import(/* webpackChunkName: "login" */ '@/views/Login.vue');
const MujUcet = () => import(/* webpackChunkName: "mujUcet" */ '@/views/MujUcet.vue');
const Nastaveni = () => import(/* webpackChunkName: "nastaveni" */ '@/views/Nastaveni.vue');
const NotFound = () => import(/* webpackChunkName: "notFound" */ '@/views/NotFound.vue');
const Osoby = () => import(/* webpackChunkName: "osoby" */ '@/views/Osoby.vue');
const PojistneUdalosti = () => import(/* webpackChunkName: "pojistneUdalosti" */ '@/views/PojistneUdalosti.vue');
const Pneumatiky = () => import(/* webpackChunkName: "pneumatiky" */ '@/views/Pneumatiky.vue');
const Pobocky = () => import(/* webpackChunkName: "pobocky" */ '@/views/Pobocky.vue');
const Podpis = () => import(/* webpackChunkName: "podpis" */ '@/views/Podpis.vue');
const Pojistovny = () => import(/* webpackChunkName: "pojistovny" */ '@/views/Pojistovny.vue');
const Rastry = () => import(/* webpackChunkName: "rastry" */ '@/views/Rastry.vue');
const Udalosti = () => import(/* webpackChunkName: "udalosti" */ '@/views/Udalosti.vue');
const Uzivatele = () => import(/* webpackChunkName: "uzivatele" */ '@/views/Uzivatele.vue');
const Vozidla = () => import(/* webpackChunkName: "vozidla" */ '@/views/Vozidla.vue');

const EventsTest = () => import(/* webpackChunkName: "eventsTest" */ '@/views/EventsTest.vue');
const AlertLog = () => import(/* webpackChunkName: "alertLog" */ '@/views/AlertLog.vue');

Vue.use(Router);

export const pageDefs = [
    ['dashboard', Dashboard, false],
    ['vozidla', [
        ['prehled', Vozidla, true],
        ['rastry', Rastry, true],
        ['ceniky', Ceniky, true],
        ['cases', Cases, true],
    ]],
    ['klienti', Klienti, true],
    ['osoby', Osoby, true],
    ['pojistneUdalosti', PojistneUdalosti, true],
    ['nastaveni', [
        ['obecne', Nastaveni, false],
        ['uzivatele', Uzivatele, true],
        ['pobocky', Pobocky, true],
        ['pojistovny', Pojistovny, true],
        ['pneumatiky', Pneumatiky, true],
        ['udalosti', Udalosti, false],
    ]],
    ['mujUcet', MujUcet, false],

    ['eventsTest', EventsTest, false],
    ['alertLog', AlertLog, false],
];

function singleDefToPage([path, component, isMasterDetail], idx, parentPath) {
    const parentPrefix = parentPath ? `${parentPath}/` : '';
    const detailSuffix = isMasterDetail ? '/:id?' : '';

    return {
        path: `/app/${parentPrefix}${path}${detailSuffix}`,
        name: idx === 0 ? parentPath : path,
        component,
    };
}

function multiDefToPages([path, subDefs]) {
    return [
        {
            path: `/app/${path}`,
            redirect: { name: path },
        },
        ..._.map(subDefs, (sd, idx) => singleDefToPage(sd, idx, path)),
    ];
}

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            name: 'home',
            redirect: '/app/dashboard',
        },
        {
            path: '/app',
            redirect: '/',
        },
        {
            path: '/app/login',
            name: 'login',
            component: Login,
            meta: {
                isPublic: true,
            },
        },
        ...pageDefs.flatMap(def => Array.isArray(def[1]) ? multiDefToPages(def) : singleDefToPage(def)),
        {
            path: '/podpis',
            name: 'podpis',
            component: Podpis,
            meta: {
                isPublic: true,
            },
        },
        {
            path: '*',
            name: 'notFound',
            component: NotFound,
            meta: {
                isPublic: true,
            },
        },
    ],
});

router.beforeEach((to, from, next) => {
    if (to.name === 'login') {
        axios.cancelAll();
    }

    if (to.name === 'login' && localStorage.getItem('authToken')) {
        const path = sessionStorage.getItem('redirectPath') || '/';
        sessionStorage.removeItem('redirectPath');
        next(path);
        return;
    }

    if (!to.meta.isPublic && !localStorage.getItem('authToken')) {
        sessionStorage.setItem('redirectPath', to.fullPath);
        next({ name: 'login' });
        return;
    }

    next();
});

export default router;
